import { useState } from "react";
import { EditGroupPayload } from "../types";
import { groupApi } from "../api/group.service";

export const useEdit = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (payload: EditGroupPayload) => {
    try {
      setLoading(true);

      const response: any = await groupApi.update(payload);

      return {
        success: true,
        message: response?.data?.message,
      };
    } catch (err: any) {
      console.log("Edit group information failed:", err);

      return {
        success: false,
        message: err?.response?.data?.error?.message_vi || "Something wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
